import Board from "../models/board";
import Todo from "../models/todo";
import { apiResultSuccess, getTodosData, orderToDos } from "../apihelper";
import { TodoSubject } from "../components/Subject";
import { GeneralObserver } from "../components/Observer";
import userManager from '../components/user-manager';

export default class TodosController extends Board {
    constructor(
        id=-1, 
        title='', 
        type='', 
        orderIndex=-1,
        dateCreated='',
        lastUpdated='', 
        hidden=false
    ) {
        super(id, title, type, orderIndex, dateCreated, lastUpdated, hidden);

        this.data = [];
        this.todos = [];
        this.subject = new TodoSubject();
        this.orderMode = false;
        this.observer = false;

        this.bindFunctions();

    }

    bindFunctions() {
        this.reactToEvent = this.reactToEvent.bind(this);
        this.setupChildObserver = this.setupChildObserver.bind(this);
        this.childReactFn = this.childReactFn.bind(this);
        this.toggleOrderMode = this.toggleOrderMode.bind(this);
    }

    setData(data) {
        this.data = data;
        // this.updateTodos();
        // this.createObserver();
    }

    getTodos() {
        return this.todos;
    }

    setTodos(newTodos=[]) {
        this.todos = newTodos;
    }

    getOrderMode() {
        return this.orderMode;
    }

    reactToEvent(event={}) {
        // use subject here and pass notify observers
        this.subject.runEvent(event);
    }

    // Adds child observer and calls childRectfn
    // To react to todoItem events
    setupChildObserver(childCtrl) {
        this.childObserver = new GeneralObserver(this.childReactFn);
        childCtrl.addObserver(this.childObserver);
    }

    childReactFn(event) {
        const newEvent = { name: 'childUpdate', value: event.value };
        this.subject.runEvent(newEvent);
    }

    // API helper
    // Checks for success result
    // Upon success calls createTodos
    // Runs reload on subject
    handleAPIResult(results) {
        if ( apiResultSuccess(results) ) {
            if ( results.todos ) {
                this.createTodos(results.todos);
                this.subject.runReload();
            }
        }
    }

    // 
    // Create
    //

    // Iterates through newTodos
    // Creates a ToDo for each
    // appens it to a new arrayy
    // Updates todos with new arra
    createTodos(newTodos=[]) {
        const todos = [];

        newTodos.forEach(data => {
            const todo = new Todo(data);
            todos.push(todo);
        });

        this.setTodos(todos);
    }

    // Creates a new Todo from newData
    // Adds it to todos array
    // Notifies subject to reload
    addNew(newData) {
        const newTodo = new Todo(newData);
        newTodo.animate = true;

        this.todos.unshift(newTodo);
        this.subject.runReload();
    }

    // Not sure if this is needed

    createObserver() {
        this.observer = new GeneralObserver(this.reactToEvent);

        this.todos.forEach(todoCtrl => {
            todoCtrl.addObserver(this.observer);
        });
    }
 
    // 
    // Read
    // 
    
    fetchData() {
        this.fetchTodos();
    }

    // Fetch todos data form API
    // When done call handleAPIResult fn
    async fetchTodos() {
        return await getTodosData(
            (results) => {
                this.handleAPIResult(results);
            }, this.id
        );
    }

    // Refect Todos
    async reloadData() {
        return await this.fetchTodos();
    }


    // 
    // Delete
    // 

    // Filters todos array by id
    // Assigns to todos
    // Notifies subject to reload
    delete(id=-1) {
        if ( id !== -1 ) {
			const newToDos = this.todos.filter(toDo => toDo.id !== id);
			this.setTodos(newToDos);
            this.subject.runReload();
            userManager.removeCollapsedItem(id);
		}
    }


    // Updates todos order by calling API orderToDos
    // On success, reloads data
    // toDoIds: array of ids
    updateToDosOrder(toDoIds=[]) {
        const postData = { board_id: this.id, todo_ids: toDoIds };
        orderToDos(
            (result) => {
                if ( apiResultSuccess(result) ) {
                    this.handleAPIResult(result);
                } 
            },
            postData
        );
    }

    // Toggles order mode
    toggleOrderMode() {
        this.orderMode = !this.orderMode;
    }
}